var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderVietcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.97021H6C5.175 4.97021 4.5 5.64522 4.5 6.47021V7.97021H16.5V15.4702H18C18.825 15.4702 19.5 14.7952 19.5 13.9702V6.47021C19.5 5.64522 18.825 4.97021 18 4.97021ZM22.5 0.470215H10.5C9.675 0.470215 9 1.14521 9 1.97021V3.47021H21V10.9702H22.5C23.325 10.9702 24 10.2952 24 9.47021V1.97021C24 1.14521 23.325 0.470215 22.5 0.470215ZM13.5 9.47021H1.5C0.675 9.47021 0 10.1452 0 10.9702V18.4702C0 19.2952 0.675 19.9702 1.5 19.9702H13.5C14.325 19.9702 15 19.2952 15 18.4702V10.9702C15 10.1452 14.325 9.47021 13.5 9.47021ZM12 16.9702H3V12.4702H12V16.9702Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderVietcan);
export default __webpack_public_path__ + "static/media/folderVietcan.c3535ae6340e6c60cc5d24ee5d5be735.svg";
export { ForwardRef as ReactComponent };